<template>
  <div class="d-flex flex-column gap-3">
    <div>
      Please review the license information below. If everything looks accurate, click "Finish" to complete your license
      application.
    </div>
    <div>
      <h6 class="fw-semibold">Property</h6>
      <div class="card p-3">
        <div>{{ model.addressFormatted }}</div>
        <div v-if="model.parcelId">Parcel #{{ model.parcelId }}</div>
      </div>
    </div>
    <div>
      <h6 class="fw-semibold">Contact</h6>
      <div class="card p-3 d-flex flex-column gap-3">
        <div v-if="model.contact.name">
          <label class="form-label fw-bold">Name</label>
          <div>
            {{ model.contact.name }}
          </div>
        </div>
        <div v-if="model.contact.address">
          <label class="form-label fw-bold">Address</label>
          <div>{{ model.contact.address }}</div>
        </div>
        <div v-if="model.contact.email">
          <label class="form-label fw-bold">Email</label>
          <div>{{ model.contact.email }}</div>
        </div>
        <div v-if="model.contact.phone">
          <label class="form-label fw-bold">Phone Number</label>
          <div>{{ formatPhone(model.contact.phone) }}</div>
        </div>
      </div>
    </div>
    <div>
      <h6 class="fw-semibold">Listings</h6>
      <div class="card p-3">
        <div v-if="model.listings.length === 0">None</div>
        <div v-for="listing in model.listings" :key="listing" class="mb-3">
          <ListingRegistrationItem :public-view="model.city.isPublicView" small :city-id="model.cityId" :url="listing" />
        </div>
      </div>
    </div>
    <div v-if="model.hasCustomFields">
      <h6 class="fw-semibold">Additional Details</h6>
      <div class="card p-3">
        <LicenseApplicationCustomFields :model="model" />
      </div>
    </div>
  </div>
</template>

<script>
import {LicenseEditorModel} from "@/models/LicenseEditorModel";
import ListingRegistrationItem from "@/components/register/ListingRegistrationItem.vue";
import LicenseApplicationCustomFields from "@/components/register/LicenseApplicationCustomFields.vue";

export default {
  components: {LicenseApplicationCustomFields, ListingRegistrationItem},
  props: {
    model: LicenseEditorModel
  }
}
</script>

